import { useState } from 'react';
import SipaDesignerPage from '../Sipa/SipaDesignerPage';
import SipaConfigPage from './SipaConfigPage';
import SipaWorkflowConfigPage from './SipaWorkflowConfigPage';
import { FaDraftingCompass, FaFileImport, FaCogs } from 'react-icons/fa';
import './SipaSettingsPage.scss';

const TABS = [
    { key: 'designer', label: 'Designer', icon: FaDraftingCompass },
    { key: 'importExport', label: 'Import & Export', icon: FaFileImport },
    { key: 'workflow', label: 'Workflow Config', icon: FaCogs }
];

/**
 * SipaSettingsPage — tabbed wrapper that consolidates the three SIPA
 * configuration pages (Designer, Import/Export, Workflow Config) into
 * a single settings entry, following the ITServiceDeskPage pattern.
 *
 * @param {string} [initialTab='designer'] – key of the tab to show first
 */
const SipaSettingsPage = ({ initialTab = 'designer' }) => {
    const [activeTab, setActiveTab] = useState(initialTab);

    return (
        <div className="sipa-settings-page">
            <div className="sipa-settings-header">
                <h1>🔍 SIPA Configuration</h1>
                <p className="sipa-settings-desc">
                    Design inspection forms, import/export form structures, and configure sign-off workflows.
                </p>
            </div>

            <div className="sipa-settings-tabs">
                {TABS.map(tab => (
                    <button
                        key={tab.key}
                        className={`sipa-settings-tab ${activeTab === tab.key ? 'active' : ''}`}
                        onClick={() => setActiveTab(tab.key)}
                    >
                        <tab.icon /> {tab.label}
                    </button>
                ))}
            </div>

            <div className="sipa-settings-tab-content">
                {activeTab === 'designer' && <SipaDesignerPage />}
                {activeTab === 'importExport' && <SipaConfigPage />}
                {activeTab === 'workflow' && <SipaWorkflowConfigPage />}
            </div>
        </div>
    );
};

export default SipaSettingsPage;
